module.exports = __webpack_public_path__ + "img/client_1.ef442762.png";